export default __webpack_public_path__ + "static/media/placeholder_store05-fr-web.fadcdf5e.png";